var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('object-thumbnail',{attrs:{"url":_vm.item.thumbnail,"frame":_vm.item.fullframe},on:{"preview":function (ref) {
	var src = ref.src;

	return _vm.previewHandler(src);
}}})}
var staticRenderFns = []

export { render, staticRenderFns }